var alignment_rtlignore_default = {
  "alignLeft": "seh-o",
  "textWrapNowrap": "G38MI",
  "alignRight": "vWP7b",
  "alignCenter": "yOjTY",
  "sizeFullWidth": "_0Dc6z",
  "renderedInTable": "eRfn6",
  "sizeOriginal": "DuvoX",
  "sizeContent": "YZq-e",
  "sizeSmall": "WDSAZ",
  "sizeSmallCenter": "m4wns",
  "flex": "_-8Lm4",
  "LEFT": "f-r5L",
  "CENTER": "p65Ia",
  "RIGHT": "reFwJ",
  "AUTO": "OL17I",
  "JUSTIFY": "SpWlR"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
